import { render, staticRenderFns } from "./ProductDetailAdd.vue?vue&type=template&id=44210e27"
import script from "./ProductDetailAdd?vue&type=script&lang=ts&external"
export * from "./ProductDetailAdd?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports